// extracted by mini-css-extract-plugin
module.exports = {"container":"Contact_container__12_si","submit":"Contact_submit__1M3nX","title":"Contact_title__F2Y6N","error":"Contact_error__ct78K"};